var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-wd": "rootView" } },
    [
      _c("router-view", { attrs: { name: "admin" } }),
      _vm._v(" "),
      _vm.pending
        ? _c("rg-loader")
        : [
            _vm.isAfterClosing
              ? _c(
                  "div",
                  { staticClass: "ui container", class: _vm.$style.notice },
                  [
                    _c("div", { staticClass: "ui huge message" }, [
                      _c("p", [
                        _c("strong", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("closingMessage", {
                                closingTime: _vm.closingTimeLocale
                              })
                            )
                          }
                        })
                      ])
                    ])
                  ]
                )
              : [
                  _vm.appBlocked
                    ? _c(
                        "div",
                        {
                          staticClass: "ui container",
                          class: _vm.$style.notice
                        },
                        [
                          _c("div", { staticClass: "ui huge message" }, [
                            _c("p", [
                              _c("strong", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.access.blockedMessage)
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    : [
                        _c("router-view", { attrs: { name: "toolbar" } }),
                        _vm._v(" "),
                        _c("rg-sidenav"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: _vm.$style.toolbarPadder },
                          [
                            _vm.isAfterNotice
                              ? _c("app-closing-banner")
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  ((_obj = {}),
                                  (_obj[_vm.$style.padder] = !_vm.$route.meta
                                    .noRootPadding),
                                  _obj)
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    class:
                                      ((_obj$1 = {}),
                                      (_obj$1[_vm.$style.contentWidth] = !_vm
                                        .$route.meta.noContentWidth),
                                      _obj$1)
                                  },
                                  [
                                    _vm.viewErrorCode
                                      ? _c(
                                          "div",
                                          [
                                            _c("empty-state", [
                                              _c(
                                                "p",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(_vm.errorMessage) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "function" },
                                                  slot: "function"
                                                },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "ui icon button large",
                                                      attrs: {
                                                        to: { name: "library" },
                                                        replace: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm._f("cap")(
                                                              _vm.$t(
                                                                "terms.backToLibrary"
                                                              )
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.unknownError,
                                                          expression:
                                                            "unknownError"
                                                        }
                                                      ],
                                                      class: _vm.$style.mail,
                                                      attrs: {
                                                        href: _vm.emailHref
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "links.email"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          [
                                            _c(
                                              "rg-loader",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.viewPending,
                                                    expression: "viewPending"
                                                  }
                                                ]
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("inprogress"))
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.isLoggedIn
                                              ? _c(
                                                  "keep-alive",
                                                  {
                                                    attrs: {
                                                      include:
                                                        _vm.namesForCache,
                                                      max: 5
                                                    }
                                                  },
                                                  [
                                                    _c("router-view", {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: !_vm.viewPending,
                                                          expression:
                                                            "!viewPending"
                                                        }
                                                      ],
                                                      key: _vm.$route.fullPath
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _c("router-view", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !_vm.viewPending,
                                                      expression: "!viewPending"
                                                    }
                                                  ],
                                                  key: _vm.$route.fullPath
                                                })
                                          ],
                                          1
                                        )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("button-to-top")
                      ]
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }